
import { FormState__setValidationResponse_5219762A, FormState__startLoading, FormState_get_empty } from "../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { deleteNotification } from "../Requests/Notification.js";
import { Cmd_errorToast, Cmd_successToast } from "../Components/Toast.js";
import { ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export function init() {
    return [new State(FormState_get_empty(), undefined), Cmd_none()];
}

export function update(onDeleteSuccess, msg, state) {
    switch (msg.tag) {
        case 1: {
            const matchValue = state.NotificationToDelete;
            if (matchValue == null) {
                return [state, Cmd_none()];
            }
            else {
                const notificationId_1 = matchValue;
                return [new State(FormState__startLoading(state.FormState), state.NotificationToDelete), deleteNotification(notificationId_1, (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(4, [Item_1])))];
            }
        }
        case 2:
            return [new State(state.FormState, undefined), Cmd_none()];
        case 3: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.NotificationToDelete), Cmd_none()];
            }
            else {
                return [new State(FormState_get_empty(), undefined), Cmd_batch(ofArray([Cmd_successToast("general.deleted_successfully"), Cmd_ofEffect((_arg) => {
                    onDeleteSuccess();
                })]))];
            }
        }
        case 4:
            return [new State(FormState_get_empty(), undefined), Cmd_errorToast("general.error")];
        default:
            return [new State(state.FormState, msg.fields[0]), Cmd_none()];
    }
}

